module.exports = __webpack_public_path__ + "media/Loops 90 Perc.c19a6e1f.wav";